import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { trackConversion } from "@/lib/analytics";

export default function ProtestAnnouncement() {
  const { t } = useTranslation();

  return (
    <aside
      aria-label={t("protestAnnouncement.label")}
      className="fixed inset-x-0 top-0 z-[60] border-b border-accent-500/30 bg-black/95 shadow-[0_8px_24px_rgba(0,0,0,0.45)] backdrop-blur-md"
    >
      <div className="mx-auto flex min-h-12 max-w-7xl flex-wrap items-center justify-center gap-x-3 gap-y-1 px-3 py-2 text-center text-[10px] leading-relaxed sm:px-5 sm:text-xs">
        <span className="inline-flex items-center gap-1.5 font-label uppercase tracking-[0.13em] text-accent-400">
          <span className="h-1.5 w-1.5 rounded-full bg-accent-500 animate-pulse" />
          {t("protestAnnouncement.kicker")}
        </span>
        <span className="text-foreground-300">
          <strong className="font-medium text-foreground-100">
            {t("protestAnnouncement.hearingStatus", { defaultValue: "Final Extradition Hearings 11-19, 11-20" })}
          </strong>
        </span>
        <Link
          to="/miami-protest"
          onClick={() => trackConversion("protest_details", t("protestAnnouncement.detailsButton"))}
          className="inline-flex items-center gap-1 whitespace-nowrap font-label uppercase tracking-[0.1em] text-accent-400 transition-colors hover:text-accent-300 focus:outline-none focus-visible:ring-2 focus-visible:ring-accent-400 focus-visible:ring-offset-2 focus-visible:ring-offset-black"
        >
          {t("protestAnnouncement.detailsButton")}
          <i className="ri-arrow-right-line" aria-hidden="true" />
        </Link>
        <Link
          to="/donate"
          onClick={() => trackConversion("donation", t("protestAnnouncement.donateButton"))}
          className="inline-flex items-center gap-1 whitespace-nowrap font-label uppercase tracking-[0.1em] text-foreground-100 transition-colors hover:text-accent-300 focus:outline-none focus-visible:ring-2 focus-visible:ring-accent-400 focus-visible:ring-offset-2 focus-visible:ring-offset-black"
        >
          {t("protestAnnouncement.donateButton")}
          <i className="ri-heart-line" aria-hidden="true" />
        </Link>
      </div>
    </aside>
  );
}